import classnames from 'classnames';
import {
  ArticleSponsor,
  Container,
  EstimatedReadingTime,
  Heading,
  Paragraph,
  ShareTray,
  Badge,
  VideoArticleProps,
} from '@stadionhq-v3/base-ui';
import { Author } from '@components/v3/molecules/author';
import { Date } from '@components/v3/atoms/date';
import { CategoryLink } from '@components/v3/atoms/category-link';
import {
  ArticleHeaderProps,
  GalleryHeaderProps,
  NewsHeaderProps,
} from '@components/v3/organisms/article-headers/articleHeader.types';
import styles from './articleHeader.module.scss';

const ArticleHeader = ({
  nativeProps,
  classNames,
  category,
  publishDate,
  author,
  sponsor,
  summary,
  // teamIndicator,
  title,
  onDark,
  estimatedReadingTime,
  shareTray,
  type,
  membersBadge,
  contain = true,
  ...rest
}: ArticleHeaderProps) => {
  const classes = classnames(
    [
      styles.articleHeader,
      styles.tokens,
      contain && styles.contain,
      [
        type === 'News' && styles.newsVariant,
        type === 'Gallery' && styles.galleryVariant,
        type === 'Video' && styles.videoVariant,
      ],
    ],
    classNames
  );

  if (type === 'Gallery' || type === 'News') {
    const { image } = rest as NewsHeaderProps | GalleryHeaderProps;

    return (
      <div {...nativeProps} className={classes}>
        <div className={classnames(styles.contentContainer)}>
          <div className={classnames(styles.topContainer)}>
            {membersBadge && (
              <Badge
                {...membersBadge}
                classNames={[classnames(styles.membersOnly)]}
              />
            )}

            {sponsor?.image && (
              <ArticleSponsor
                {...sponsor}
                onDark={onDark}
                classNames={[classnames(styles.sponsorContainer)]}
              />
            )}
          </div>

          <div className={classnames(styles.mainContentContainer)}>
            {/* {teamIndicator && (
             <div className={classnames(styles.teamIndicator)}>
               <TeamIndicator team={teamIndicator} onDark={onDark} />
             </div>
            )} */}

            {category?.category && category?.slug && (
              <CategoryLink
                {...category}
                category={category.category}
                slug={category.slug}
                onDark={onDark}
                classNames={[
                  classnames(styles.categoryLink, category.classNames),
                ]}
              />
            )}

            <Heading as="h3" classNames={[classnames(styles.title)]}>
              {title}
            </Heading>

            <div className={classnames(styles.articleInfo)}>
              {publishDate?.date && (
                <Date
                  {...publishDate}
                  onDark={onDark}
                  classNames={[
                    classnames(styles.publishDate, publishDate.classNames),
                  ]}
                />
              )}

              {!!(
                publishDate?.date && estimatedReadingTime?.estimatedReadingTime
              ) && <span className={classnames(styles.divider)} />}

              {estimatedReadingTime?.estimatedReadingTime && (
                <EstimatedReadingTime
                  {...estimatedReadingTime}
                  classNames={[classnames(styles.readingTime)]}
                />
              )}
            </div>

            {summary && (
              <Paragraph classNames={[classnames(styles.summary)]}>
                {summary}
              </Paragraph>
            )}
          </div>

          {Boolean(author || shareTray?.sharePlatforms.length) && (
            <div className={classnames(styles.footer)}>
              {author && (
                <Author
                  {...author}
                  onDark={onDark}
                  classNames={[classnames(styles.author)]}
                />
              )}

              {shareTray?.sharePlatforms && (
                <ShareTray
                  {...shareTray}
                  onDark={onDark}
                  classNames={[classnames(styles.shareTray)]}
                />
              )}
            </div>
          )}
        </div>

        <div className={styles.imageContainer}>
          {image && <div className={classnames(styles.image)}>{image}</div>}
          {type === 'Gallery' && (
            <div className={classnames(styles.gradientOverlay)} />
          )}
        </div>
      </div>
    );
  }

  if (type === 'Video') {
    const { featuredVideo } = rest as VideoArticleProps;
    return (
      <div {...nativeProps} className={classes}>
        <Container classNames={[classnames(styles.contentContainer)]}>
          <div className={classnames(styles.topContainer)}>
            {membersBadge ? (
              <Badge
                {...membersBadge}
                classNames={[classnames(styles.membersOnly)]}
              />
            ) : null}

            {sponsor?.image && (
              <ArticleSponsor
                {...sponsor}
                onDark={onDark}
                classNames={[classnames(styles.sponsorContainer)]}
              />
            )}
          </div>

          {featuredVideo && (
            <div className={classnames(styles.videoPlayer)}>
              {featuredVideo}
            </div>
          )}

          <div className={classnames(styles.mainContentContainer)}>
            {/* {teamIndicator && ( */}
            {/*  <div className={classnames(styles.teamIndicator)}> */}
            {/*    <TeamIndicator team={teamIndicator} onDark={onDark} /> */}
            {/*  </div> */}
            {/* )} */}

            {category?.category && category?.slug && (
              <CategoryLink
                {...category}
                category={category.category}
                slug={category.slug}
                onDark={onDark}
                classNames={[
                  classnames(styles.categoryLink, category.classNames),
                ]}
              />
            )}

            <Heading as="h3" classNames={[classnames(styles.title)]}>
              {title}
            </Heading>

            <div className={classnames(styles.articleInfo)}>
              {publishDate?.date && (
                <Date
                  {...publishDate}
                  onDark={onDark}
                  classNames={[
                    classnames(styles.publishDate, publishDate.classNames),
                  ]}
                />
              )}
            </div>

            {summary && (
              <Paragraph classNames={[classnames(styles.summary)]}>
                {summary}
              </Paragraph>
            )}
          </div>

          <div className={classnames(styles.footer)}>
            {author && (
              <Author
                {...author}
                onDark={onDark}
                classNames={[classnames(styles.author)]}
              />
            )}
            {shareTray?.sharePlatforms && (
              <ShareTray
                {...shareTray}
                onDark={onDark}
                classNames={[classnames(styles.shareTray)]}
              />
            )}
          </div>
        </Container>
      </div>
    );
  }
  return undefined;
};

export default ArticleHeader;
